import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface DividerBlockRendererProps {
  block: { settings: Record<string, any> };
  config: TemplateConfig;
}

const DividerBlockRenderer: React.FC<DividerBlockRendererProps> = ({ block, config }) => {
  const s = block.settings;
  const color = typeof s.color === 'string' ? s.color : config.aksanRenk;
  const thickness =
    typeof s.thickness === 'number' && Number.isFinite(s.thickness) && s.thickness > 0
      ? s.thickness
      : 1;
  const styleRaw = s.style;
  const borderStyle =
    styleRaw === 'dashed' || styleRaw === 'dotted' || styleRaw === 'solid'
      ? styleRaw
      : 'solid';

  return (
    <div
      role="separator"
      style={{
        width: '100%',
        margin: '8px 0',
        border: 'none',
        borderTop: `${thickness}px ${borderStyle} ${color}`,
        height: 0,
        padding: 0,
      }}
    />
  );
};

export default DividerBlockRenderer;
